<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :bodyFilter="true"
      :customTopActions="true"
      item-key="id"
      table-height="70vh"
    >     
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer />
          <v-dialog v-model="dialog" max-width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="warning"
                class="mb-2"
                @click="getData"
                :loading="loading"
                :disabled="loading"
                ><v-icon>mdi-refresh</v-icon
                ><template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>
              <v-btn
                color="primary"
                class="mb-2 rounded-pill elevation-0"
                v-bind="attrs"
                :style="{ 'margin-right': '10px' }"
                v-on="on"
              >
                Add Data
              </v-btn>
            </template>
            <v-card>
              <v-form>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.mcc"
                          label="Kode MCC"
                          :error-messages="mccCodeErrors"
                          @change="$v.editedItem.mcc.$touch()"
                          @blur="$v.editedItem.mcc.$touch()"
                          :disabled="view"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.description"
                          label="Deskripsi MCC"
                          :error-messages="descriptionErrors"
                          @change="$v.editedItem.description.$touch()"
                          @blur="$v.editedItem.description.$touch()"
                          :disabled="view"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-select
                          v-model="editedItem.category_id"
                          :error-messages="mccCategoryErrors"
                          @change="$v.editedItem.category_id.$touch()"
                          @blur="$v.editedItem.category_id.$touch()"
                          :items="allCategory"
                          label="Category"
                          item-text="text"
                          item-value="value"
                          :disabled="view"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.mcc_name"
                          :error-messages="jenisUsahaErrors"
                          @change="$v.editedItem.mcc_name.$touch()"
                          @blur="$v.editedItem.mcc_name.$touch()"
                          label="Jenis Usaha"
                          :disabled="view"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.mdr_on_us"
                          :error-messages="mdrOnUsErrors"
                          @change="$v.editedItem.mdr_on_us.$touch()"
                          @blur="$v.editedItem.mdr_on_us.$touch()"
                          label="MDR On Us"
                          :disabled="view"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.mdr_off_us"
                          :error-messages="mdrOffUsErrors"
                          @change="$v.editedItem.mdr_off_us.$touch()"
                          @blur="$v.editedItem.mdr_off_us.$touch()"
                          label="MDR Off Us"
                          :disabled="view"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-select
                          v-model="editedItem.status"
                          :error-messages="statusErrors"
                          @change="$v.editedItem.status.$touch()"
                          @blur="$v.editedItem.status.$touch()"
                          :items="listMccMdrStatus"
                          label="Status"
                          item-text="text"
                          item-value="value_number"
                          :disabled="view"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions style="padding: 16px;">
                  <v-spacer />
                  <v-btn dark color="red" @click="close">
                    Cancel
                  </v-btn>
                  <v-btn
                    v-if="!view"
                    color="primary"
                    :disabled="loading"
                    @click="save"
                  >
                    <span v-if="!loading">Save</span>
                    <v-progress-circular
                      v-if="loading"
                      indeterminate
                      color="primary"
                    />
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialogView"
            max-width="600px"
            @click:outside="close"
          >
            <v-card>
              <v-form>
                <v-card-title>
                  <span class="headline">View Detail</span>
                </v-card-title>

                <v-card-text style="margin-bottom: 32px;">
                  <v-container>
                    <data-detail-row
                      label="Kode MCC"
                      :data="editedItem"
                      :valueData="editedItem.mcc"
                      noGutters
                    />
                    <data-detail-row
                      label="Deskripsi MCC"
                      :data="editedItem"
                      :valueData="editedItem.description"
                      noGutters
                    />
                    <data-detail-row
                      label="Kategori"
                      :data="editedItem"
                      :valueData="
                        editedItem.category_id != ''
                          ? allCategory[editedItem.category_id - 1]['text']
                          : ''
                      "
                      noGutters
                    />
                    <data-detail-row
                      label="Jenis Usaha"
                      :data="editedItem"
                      :valueData="editedItem.mcc_name"
                      noGutters
                    />
                    <data-detail-row
                      label="MDR On Us"
                      :data="editedItem"
                      :valueData="editedItem.mdr_on_us"
                      noGutters
                    />
                    <data-detail-row
                      label="MDR Off Us"
                      :data="editedItem"
                      :valueData="editedItem.mdr_off_us"
                      noGutters
                    />
                    <data-detail-row
                      label="Status"
                      :data="editedItem"
                      :valueData="
                        editedItem.status != ''
                          ? textStatus(editedItem.status)
                          : ''
                      "
                      noGutters
                    />
                  </v-container>
                </v-card-text>

                <v-card-actions class="justify-center" style="padding: 16px;">
                  <v-btn dark color="red" @click="close" style="padding: 0 32px;">
                    Close
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="600px">
            <v-card>
              <v-card-title class="headline justify-center" style="margin-bottom: 32px;">
                Are you sure you want to deactivate this item?
              </v-card-title>
              <v-card-actions class="justify-center" style="padding: 16px;">
                <v-spacer />
                <v-btn dark color="red" @click="closeDelete">Cancel</v-btn>
                <v-btn color="primary" @click="deleteItemConfirm">OK</v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-toolbar>
      </template>
      <template v-slot:body-prepend>
        <BodyFilterView
          :filters="filterData"
          :search.sync="search"
          :options.sync="options"
          @getDataParent="getData"
        />
      </template>
      <template slot="action" slot-scope="{ item }">
          <v-icon small class="mr-2" @click="viewItem(item)"> mdi-eye </v-icon>
          <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-check </v-icon>
      </template>
      <template v-slot:custom_status="{ item }">
          <div class="d-flex flex-column" :style="{ padding: '8px 0' }">
          {{ getStatusLabel(item.status) }}
        </div>
      </template>
    </TableView>

  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, numeric, maxLength } from 'vuelidate/lib/validators';
import {regexNumericDecimalOne } from '../../lib/helpers';
import mccMdrMixin from '../../components/setting-fee/mcc-mdr/mccMdrMixin';


export default {
  components: {
    DataDetailRow: () => import('../../components/detail/DataDetailRow.vue'),
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    BodyFilterView: () => import("../../components/@drontVue/components/BodyFilter"),
  },
  mixins: [validationMixin, mccMdrMixin],
  validations: {
    editedItem: {
      mcc: { required, numeric, maxLength: maxLength(4) },
      description: { required },
      category_id: { required },
      mcc_name: { required },
      mdr_on_us: { required, numericDecimal: regexNumericDecimalOne },
      mdr_off_us: { required, numericDecimal: regexNumericDecimalOne },
      status: { required },
    },
  },

};
</script>
<style>
.v-data-table .v-data-table-header tr th {
  font-size: 18px !important;
}
</style>
